import { makeStyles } from '@material-ui/core/styles';
import { Theme } from 'enum';

export const useStyles = makeStyles((theme) => {
    return {
        sectionTitle: {
            width: '100%',
            paddingTop: '6px',
            height: '45px',
            fontSize: 17,
            fontWeight: 700,
            color: theme.palette.type === Theme.Light ? '#333' : '#FFF',
        },
        summary: {
            marginBottom: theme.spacing(2),
            paddingLeft: 20,
        },
    };
});
